<template>
  <common-dialog ref="dialog" width="600px" show-save-button title="添加地址标记" id-key="id" :data="data" :form-rules="rules"
    :save-func="saveDataFunc" @close-saved="$emit('close-saved')" close-on-saved>
    <template slot="form">
      <el-form-item prop="address" label-width="0">
        <el-input v-model="data.address" placeholder="请输入地址关键字，逗号隔开"></el-input>
      </el-form-item>
    </template>
  </common-dialog>
</template>
<script>
import editDialogMixin from '@/mixins/editDialog';
import commonDialog from '@/components/common/dialog';

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        id: 0,
        address: '',
      },
      // api: require('@/api/ent/dp').default,
      rules: {
        address: [{ required: true, message: '地址关键字不能为空' }],
      },
    };
  },
  methods: {
    saveDataFunc() {
      return new Promise((resolve, reject) => {
        resolve({ Code: 0, Msg: null })
      })
    },
  },
};
</script>
